import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./meter.script";
export function RuiMeter(props) {
  return /* @__PURE__ */jsx("rui-meter", {
    ...props
  });
}